var exports = {
  "Qx": "xaee3c4fa--8ded65--add-question__wrapper",
  "u0": "xaee3c4fa--8ded65--breadcrumbs-wrap",
  "Ve": "xaee3c4fa--8ded65--breadcrumbs-wrap-mobile",
};

module.exports = exports;
